import React from 'react';
import PropTypes from 'prop-types';

import SrDarkModal from 'client/components/SrDarkModal';
import SrBox from 'client/components/SrBox';
import SrAdminPartnerNotes from 'client/components/SrAdminPartnerNotes/SrAdminPartnerNotes';

const SrPartnerNotesModal = ({ partnerId, dispatch, currentUser, onClose }) => {
  return (
    <SrDarkModal onClose={onClose}>
      <div className="adminModal">
        <SrBox marginTop="100px" width="600px" onClick={(event) => event.stopPropagation()}>
          <SrAdminPartnerNotes
            partnerId={partnerId}
            dispatch={dispatch}
            currentUser={currentUser}
          />
        </SrBox>
      </div>
    </SrDarkModal>
  );
};

SrPartnerNotesModal.propTypes = {
  partnerId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrPartnerNotesModal.displayName = 'SrPartnerNotesModal';

export default SrPartnerNotesModal;
